export const useFavourites = () => {
  return useState('tickslyFavourites', () => ({
    favourites: [] as string[],
    isLoading: false,
  }))
}
